import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 更新海运提单属性信息
export function updateProperties(params, data) {
  return request({
    url: URL.seaImport.updateProperties,
    method: 'post',
    params,
    data
  })
}

// 完成补料
export function completeTheFeed(params) {
  return request({
    url: URL.seaImport.completeTheFeed,
    method: 'post',
    params
  })
}

// 根据主键获取海运提单
export function getSeaCargoDoc(params) {
  return request({
    url: URL.seaImport.getSeaCargoDoc,
    method: 'get',
    params
  })
}

// 根据主键获取海运提单
export function getSeaCargoDocByJobUuid(params) {
  return request({
    url: URL.seaImport.getSeaCargoDocByJobUuid,
    method: 'get',
    params
  })
}

// 投保
export function toInsure(data) {
  return request({
    url: URL.seaImport.toInsure,
    method: 'post',
    data
  })
}

// 获取反恐舱单地址信息列表
export function getAfrAddressList(params) {
  return request({
    url: URL.seaImport.getAfrAddressList,
    method: 'get',
    params
  })
}

// 获取对单地址
export function getCfmAddress(params) {
  return request({
    url: URL.seaImport.getCfmAddress,
    method: 'get',
    params
  })
}

// 电放或者正本打印/解锁
export function surrendered(body) {
  return request({
    url: URL.seaImport.surrendered,
    method: 'get',
    params: body
  })
}

// 触发Sop节点
export function postRemotingTracking(body) {
  return request({
    url: URL.seaImport.postRemotingTracking,
    method: 'get',
    params: body
  })
}

// HBL自动放单
export function autoAuditSingleReleaseHBL(body) {
  return request({
    url: URL.seaImport.autoAuditSingleReleaseHBL,
    method: 'put',
    params: body
  })
}
